import { useState, useCallback } from "react";
import LogoAdoraTeam from "./LogoAdoraTeam";
import { auth, salvarToken } from "../Api";
import { GOLD, BLUE } from "../constants/temas";

// ✅ Input FORA do componente pai — evita recriar o elemento a cada render
// ✅ fontSize 16 — evita zoom automático no iOS
const Input = ({ label, value, onChange, type = "text", placeholder, autoComplete, inputMode }) => (
    <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: "#8899bb", marginBottom: 6, letterSpacing: 0.5 }}>{label}</div>
        <input
            type={type}
            value={value}
            onChange={e => onChange(e.target.value)}
            placeholder={placeholder}
            autoComplete={autoComplete}
            inputMode={inputMode}
            style={{
                width: "100%", padding: "13px 16px", borderRadius: 12,
                border: "1.5px solid #2a3a5e", background: "#0f1729",
                color: "white", fontSize: 16, boxSizing: "border-box",
            }}
        />
    </div>
);

export default function EntrarComCodigo({ onLogin, onVoltar }) {
    const [passo, setPasso] = useState(1);
    const [codigo, setCodigo] = useState("");
    const [grupo, setGrupo] = useState(null);
    const [form, setForm] = useState({ nome: "", email: "", senha: "", confirmarSenha: "", telefone: "", dataNascimento: "" });
    const [erro, setErro] = useState("");
    const [loading, setLoading] = useState(false);
    const [verSenha, setVerSenha] = useState(false);

    // ✅ useCallback — funções estáveis evitam re-render dos inputs no mobile
    const set = useCallback((k, v) => setForm(p => ({ ...p, [k]: v })), []);
    const setNome      = useCallback(v => set("nome", v),           [set]);
    const setEmail     = useCallback(v => set("email", v),          [set]);
    const setTelefone  = useCallback(v => set("telefone", v),       [set]);
    const setDataNasc  = useCallback(v => set("dataNascimento", v), [set]);
    const setSenha     = useCallback(v => set("senha", v),          [set]);
    const setConfirmar = useCallback(v => set("confirmarSenha", v), [set]);

    const validarCodigo = async () => {
        const c = codigo.trim().toUpperCase();
        if (!c) return setErro("Digite o código de convite");
        setLoading(true); setErro("");
        try {
            const res = await auth.validarConvite(c);
            setGrupo({ ...res.grupo, invite_code: c });
            setPasso(2);
        } catch (e) {
            setErro(e.message || "Código inválido ou expirado");
        } finally {
            setLoading(false);
        }
    };

    const avancarCadastro = () => {
        if (!form.nome || !form.email || !form.senha) return setErro("Preencha nome, e-mail e senha");
        if (form.senha.length < 6) return setErro("Senha precisa ter pelo menos 6 caracteres");
        if (form.senha !== form.confirmarSenha) return setErro("As senhas não coincidem");
        setErro("");
        setPasso(3);
    };

    const finalizar = async (perfil) => {
        setLoading(true); setErro("");
        try {
            const res = await auth.cadastroMembro({
                nome: form.nome,
                email: form.email,
                senha: form.senha,
                telefone: form.telefone,
                data_nascimento: form.dataNascimento,
                invite_code: grupo.invite_code,
                perfil_publico: perfil,
            });
            salvarToken(res.token);
            onLogin(res.usuario);
        } catch (e) {
            setErro(e.message || "Erro ao criar conta");
            setPasso(2);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: "100vh", background: BLUE,
            display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            padding: "28px 20px", boxSizing: "border-box"
        }}>
            <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}`}</style>

            <div style={{ animation: "fadeUp 0.4s ease both", textAlign: "center", marginBottom: 28 }}>
                <LogoAdoraTeam size={52} glow={true} />
                <div style={{ marginTop: 10 }}>
                    <span style={{ fontSize: 22, fontWeight: 900, color: "white" }}>Adora</span>
                    <span style={{ fontSize: 22, fontWeight: 900, color: GOLD }}>Team</span>
                </div>
            </div>

            <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
                {[1, 2, 3].map(n => (
                    <div key={n} style={{
                        width: passo === n ? 28 : 8, height: 8, borderRadius: 4,
                        background: passo >= n ? GOLD : "#2a3a5e",
                        transition: "all 0.3s"
                    }} />
                ))}
            </div>

            <div style={{
                animation: "fadeUp 0.4s 0.1s ease both",
                background: "#162040", borderRadius: 24, padding: 28,
                width: "100%", maxWidth: 400, boxSizing: "border-box",
                boxShadow: "0 8px 40px #0006"
            }}>

                {/* ── PASSO 1: CÓDIGO ── */}
                {passo === 1 && (
                    <>
                        <div style={{ fontSize: 20, fontWeight: 800, color: "white", marginBottom: 4 }}>Entrar no grupo 🎵</div>
                        <div style={{ fontSize: 13, color: "#8899bb", marginBottom: 24 }}>
                            Digite o código de convite que seu líder compartilhou
                        </div>

                        <div style={{ marginBottom: 20 }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: "#8899bb", marginBottom: 8, letterSpacing: 0.5 }}>CÓDIGO DE CONVITE</div>
                            <input
                                value={codigo}
                                onChange={e => setCodigo(e.target.value.toUpperCase())}
                                onKeyDown={e => e.key === "Enter" && validarCodigo()}
                                placeholder="Ex: LOUVOR7K2"
                                maxLength={12}
                                autoComplete="off"
                                autoCapitalize="characters"
                                style={{
                                    width: "100%", padding: "16px", borderRadius: 14,
                                    border: `2px solid ${codigo.length >= 8 ? GOLD : "#2a3a5e"}`,
                                    background: "#0f1729", color: "white",
                                    fontSize: 22, fontWeight: 800, letterSpacing: 4,
                                    textAlign: "center", boxSizing: "border-box",
                                    transition: "border-color 0.2s"
                                }}
                            />
                        </div>

                        {erro && (
                            <div style={{ background: "#f4433618", border: "1px solid #f4433644", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#ff6b6b" }}>
                                ⚠️ {erro}
                            </div>
                        )}

                        <button onClick={validarCodigo} disabled={loading} style={{
                            width: "100%", padding: 15, borderRadius: 14,
                            background: loading ? "#2a3a5e" : `linear-gradient(135deg, ${GOLD}, #FFD166)`,
                            border: "none", color: BLUE, fontWeight: 800, fontSize: 16,
                            cursor: loading ? "default" : "pointer",
                            boxShadow: loading ? "none" : `0 4px 20px ${GOLD}44`,
                        }}>{loading ? "Verificando..." : "Verificar código →"}</button>

                        <button onClick={onVoltar} style={{
                            width: "100%", marginTop: 12, padding: 14, borderRadius: 14,
                            background: "none", border: "1.5px solid #2a3a5e",
                            color: "#8899bb", fontWeight: 600, fontSize: 14, cursor: "pointer"
                        }}>← Voltar</button>
                    </>
                )}

                {/* ── PASSO 2: CADASTRO ── */}
                {passo === 2 && (
                    <>
                        <div style={{
                            background: `${GOLD}12`, border: `1px solid ${GOLD}33`,
                            borderRadius: 14, padding: "12px 16px", marginBottom: 20,
                            display: "flex", alignItems: "center", gap: 12
                        }}>
                            <div style={{ fontSize: 28 }}>⛪</div>
                            <div>
                                <div style={{ fontSize: 15, fontWeight: 700, color: GOLD }}>{grupo?.nome}</div>
                                {grupo?.igreja && <div style={{ fontSize: 12, color: "#8899bb" }}>{grupo.igreja}</div>}
                                <div style={{ fontSize: 11, color: "#8899bb", marginTop: 2 }}>
                                    {grupo?.membros} membro{grupo?.membros !== 1 ? "s" : ""} · Plano {grupo?.plano}
                                </div>
                            </div>
                            <div style={{ marginLeft: "auto", background: "#4caf5022", borderRadius: 8, padding: "4px 10px" }}>
                                <span style={{ fontSize: 11, color: "#4caf50", fontWeight: 700 }}>✓ Válido</span>
                            </div>
                        </div>

                        <div style={{ fontSize: 18, fontWeight: 800, color: "white", marginBottom: 4 }}>Seus dados 📋</div>
                        <div style={{ fontSize: 13, color: "#8899bb", marginBottom: 20 }}>Crie sua conta para entrar no grupo</div>

                        <Input label="NOME COMPLETO"       value={form.nome}           onChange={setNome}      placeholder="Seu nome completo"  autoComplete="name"    inputMode="text" />
                        <Input label="E-MAIL"              value={form.email}          onChange={setEmail}     type="email" placeholder="seu@email.com"  autoComplete="email"   inputMode="email" />
                        <Input label="TELEFONE (OPCIONAL)" value={form.telefone}       onChange={setTelefone}  placeholder="(47) 99999-9999"    autoComplete="tel"     inputMode="tel" />
                        <Input label="DATA DE NASCIMENTO"  value={form.dataNascimento} onChange={setDataNasc}  type="date"                       autoComplete="bday" />

                        <div style={{ marginBottom: 14 }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: "#8899bb", marginBottom: 6, letterSpacing: 0.5 }}>SENHA</div>
                            <div style={{ position: "relative" }}>
                                <input
                                    type={verSenha ? "text" : "password"}
                                    value={form.senha}
                                    onChange={e => setSenha(e.target.value)}
                                    placeholder="Mínimo 6 caracteres"
                                    autoComplete="new-password"
                                    style={{ width: "100%", padding: "13px 48px 13px 16px", borderRadius: 12, border: "1.5px solid #2a3a5e", background: "#0f1729", color: "white", fontSize: 16, boxSizing: "border-box" }}
                                />
                                <button onClick={() => setVerSenha(p => !p)} style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#8899bb" }}>
                                    {verSenha ? "🙈" : "👁"}
                                </button>
                            </div>
                        </div>
                        <Input label="CONFIRMAR SENHA" value={form.confirmarSenha} onChange={setConfirmar} type="password" placeholder="Repita a senha" autoComplete="new-password" />

                        {erro && (
                            <div style={{ background: "#f4433618", border: "1px solid #f4433644", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#ff6b6b" }}>
                                ⚠️ {erro}
                            </div>
                        )}

                        <div style={{ display: "flex", gap: 10 }}>
                            <button onClick={() => setPasso(1)} style={{ flex: 1, padding: 14, borderRadius: 14, background: "none", border: "1.5px solid #2a3a5e", color: "white", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>← Voltar</button>
                            <button onClick={avancarCadastro} style={{
                                flex: 2, padding: 14, borderRadius: 14,
                                background: `linear-gradient(135deg, ${GOLD}, #FFD166)`,
                                border: "none", color: BLUE, fontWeight: 800, fontSize: 15, cursor: "pointer",
                                boxShadow: `0 4px 20px ${GOLD}44`
                            }}>Continuar →</button>
                        </div>
                    </>
                )}

                {/* ── PASSO 3: PERFIL MÚSICO ── */}
                {passo === 3 && (
                    <>
                        <div style={{ textAlign: "center", marginBottom: 8 }}>
                            <div style={{ fontSize: 44, marginBottom: 12 }}>🎶</div>
                            <div style={{ fontSize: 20, fontWeight: 800, color: "white", marginBottom: 8 }}>
                                Perfil público de músico
                            </div>
                            <div style={{ fontSize: 14, color: "#8899bb", lineHeight: 1.6 }}>
                                Deseja criar um perfil público para aparecer na rede de músicos da plataforma?
                            </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: 12, margin: "24px 0" }}>
                            <button onClick={() => finalizar(true)} style={{
                                padding: "18px", borderRadius: 16,
                                background: `${GOLD}15`, border: `2px solid ${GOLD}44`,
                                cursor: "pointer", display: "flex", alignItems: "center", gap: 14
                            }}>
                                <span style={{ fontSize: 28 }}>🌟</span>
                                <div style={{ textAlign: "left" }}>
                                    <div style={{ fontSize: 16, fontWeight: 700, color: GOLD }}>Sim, quero um perfil público</div>
                                    <div style={{ fontSize: 12, color: "#8899bb", marginTop: 2 }}>Apareço na rede de músicos</div>
                                </div>
                            </button>
                            <button onClick={() => finalizar(false)} style={{
                                padding: "18px", borderRadius: 16,
                                background: "#0f1729", border: "2px solid #2a3a5e",
                                cursor: "pointer", display: "flex", alignItems: "center", gap: 14
                            }}>
                                <span style={{ fontSize: 28 }}>🔒</span>
                                <div style={{ textAlign: "left" }}>
                                    <div style={{ fontSize: 16, fontWeight: 700, color: "white" }}>Não, só membro do grupo</div>
                                    <div style={{ fontSize: 12, color: "#8899bb", marginTop: 2 }}>Posso mudar isso depois</div>
                                </div>
                            </button>
                        </div>

                        {erro && (
                            <div style={{ background: "#f4433618", border: "1px solid #f4433644", borderRadius: 10, padding: "10px 14px", fontSize: 13, color: "#ff6b6b" }}>
                                ⚠️ {erro}
                            </div>
                        )}

                        {loading && (
                            <div style={{ textAlign: "center", color: "#8899bb", fontSize: 13, marginTop: 12 }}>
                                Criando sua conta...
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}